import * as React from "react"
import * as TooltipPrimitive from "@radix-ui/react-tooltip"

import { cn } from "@/lib/utils"

function TooltipProvider({
  delayDuration = 0,
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Provider>) {
  return (
    <TooltipPrimitive.Provider
      data-slot="tooltip-provider"
      delayDuration={delayDuration}
      {...props}
    />
  )
}

function Tooltip({
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Root>) {
  return (
    <TooltipProvider>
      <TooltipPrimitive.Root data-slot="tooltip" {...props} />
    </TooltipProvider>
  )
}

function TooltipTrigger({
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Trigger>) {
  return <TooltipPrimitive.Trigger data-slot="tooltip-trigger" {...props} />
}

function TooltipContent({
  className,
  sideOffset = 0,
  children,
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Content>) {
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        data-slot="tooltip-content"
        sideOffset={sideOffset}
        className={cn(
          "ci:bg-foreground ci:text-background ci:animate-in ci:fade-in-0 ci:zoom-in-95 ci:data-[state=closed]:animate-out ci:data-[state=closed]:fade-out-0 ci:data-[state=closed]:zoom-out-95 ci:data-[side=bottom]:slide-in-from-top-2 ci:data-[side=left]:slide-in-from-right-2 ci:data-[side=right]:slide-in-from-left-2 ci:data-[side=top]:slide-in-from-bottom-2 ci:z-50 ci:w-fit ci:origin-(--radix-tooltip-content-transform-origin) ci:rounded-md ci:px-3 ci:py-1.5 ci:text-xs ci:text-balance",
          className
        )}
        {...props}
      >
        {children}
        <TooltipPrimitive.Arrow className="ci:bg-foreground ci:fill-foreground ci:z-50 ci:size-2.5 ci:translate-y-[calc(-50%_-_2px)] ci:rotate-45 ci:rounded-[2px]" />
      </TooltipPrimitive.Content>
    </TooltipPrimitive.Portal>
  )
}

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider }
